import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter } from 'react-router';
import { RouterProvider } from 'react-router/dom';
import Hackathon from './app/app.js';
import Events from './app/events.js';

const router = createBrowserRouter([
  {
    path: '/',
    Component: Hackathon,
  },
  {
    path: '/hackathon',
    Component: Hackathon,
  },
  {
    path: '/events',
    Component: Events,
  },
  {
    path: '/specialized-models',
    HydrateFallback: () => (
      <div className="p-8 pt-28" role="status">
        Loading models…
      </div>
    ),
    lazy: async () => ({
      Component: (await import('./app/specialized-models.js')).default,
    }),
  },
]);
const root = createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
